import React from 'react';
import './TimeOff.css';

const timeOff = ( props ) => (
	<section id="TimeOff">
		<h2>How Much <span>Time Off</span> Do I Get?</h2>
		<div className="cards">
			<div className="card">
				<p className="title">
					Years 0-3
				</p>
				<p>
					You accrue 3.33 hours of PTO per pay period
				</p>
				<p>
					(2 weeks per year)
				</p>
			</div>
			
			<div className="card">
				<p className="title">
					Years 4-5
				</p>
				<p>
					You accrue 5.0 hours of PTO per pay period
				</p>
				<p>
					(3 weeks per year)
				</p>
			</div>
			
			<div className="card">
				<p className="title">
					Years 6+
				</p>
				<p>
					You accrue 6.67 hours of PTO per pay period
				</p>
				<p>
					(4 weeks per year)
				</p>
			</div>
		</div>
	</section>
);

export default timeOff;



// WEBPACK FOOTER //
// ./src/pages/Benefits/TimeOff/TimeOff.js